import { render, staticRenderFns } from "./EventContentV1.vue?vue&type=template&id=e7e0ee28&scoped=true"
import script from "./EventContentV1.vue?vue&type=script&lang=js"
export * from "./EventContentV1.vue?vue&type=script&lang=js"
import style0 from "./EventContentV1.vue?vue&type=style&index=0&id=e7e0ee28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e0ee28",
  null
  
)

export default component.exports